module.exports = __webpack_public_path__ + "static/media/success_icon.6afa3e69.svg";